<template>
  <v-container>
    <div class="containerStyle" v-if="loader">
      <img id="loader" class="zoom" :src="img1" />
    </div>
    <div class="row">
      <div class="col-md-10 col-sm-12 col-xs-12 top">
        <v-flex lg10 md10 sm11 xs>
          <div class="form-group">
            <label class="left" for="sel1">Elige un centro de costo para cargar archivos</label>
            <select class="form-control" id="5" @change="cargaArchivos()" v-model="carrera">
              <option selected disabled>-Selecciona una opción-</option>
              <option
                v-for="(centro,index) in carreras"
                :key="index"
                :value="centro"
              >{{centro.nombre}}</option>
            </select>
          </div>
        </v-flex>
        <v-flex lg10 md10 sm11 xs v-if="carrera !=''">
          <v-card class="top">
            <h1>{{carrera.nombre}}</h1>
            <v-layout row>
              <v-flex md9 sm9 xs9>
                <v-text-field
                  label="Perfil de egreso"
                  @click="pickFile('0')"
                  v-model="FileName[0]"
                  prepend-icon="attach_file"
                  :disabled="this.filesDca['dca'][0]['saved'] == 'si'"
                ></v-text-field>
                <input
                  type="file"
                  id="file0"
                  ref="myFiles0"
                  style="display: none"
                  class="custom-file-input"
                  @change="previewFiles('0')"
                  multiple
                />
              </v-flex>

              <v-flex md2 sm1 xs1>
                <v-btn
                  v-if="this.filesDca['dca'][0]['saved'] == 'si'"
                  fab
                  outline
                  small
                  color="#394049"
                  v-on:click="downloadFile('0')"
                >
                  <v-icon dark>save_alt</v-icon>
                </v-btn>
                <v-btn
                  v-if="this.filesDca['dca'][0]['saved'] == 'no'"
                  fab
                  outline
                  small
                  color="#EC6A12"
                  v-on:click="submitFile('0')"
                  :disabled="disabled[0]"
                >
                  <v-icon color="#394049" dark>publish</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>

          <v-card>
            <v-layout row>
              <v-flex md9 sm9 xs9>
                <v-text-field
                  label="Resoluciones"
                  @click="pickFile('1')"
                  v-model="FileName[1]"
                  prepend-icon="attach_file"
                  :disabled="this.filesDca['dca'][1]['saved'] == 'si'"
                ></v-text-field>
                <input
                  type="file"
                  id="file1"
                  ref="myFiles1"
                  style="display: none"
                  class="custom-file-input"
                  @change="previewFiles('1')"
                  multiple
                />
              </v-flex>

              <v-flex md2 xs1>
                <v-btn
                  v-if="this.filesDca['dca'][1]['saved'] == 'si'"
                  fab
                  outline
                  small
                  color="#394049"
                  v-on:click="downloadFile('1')"
                >
                  <v-icon dark>save_alt</v-icon>
                </v-btn>
                <v-btn
                  v-if="this.filesDca['dca'][1]['saved'] == 'no'"
                  fab
                  outline
                  small
                  color="#EC6A12"
                  v-on:click="submitFile('1')"
                  :disabled="disabled[1]"
                >
                  <v-icon color="#394049" dark>publish</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>

          <v-card>
            <v-layout row>
              <v-flex md9 sm9 xs9>
                <v-text-field
                  label="Estudios de opinión"
                  @click="pickFile('3')"
                  v-model="FileName[3]"
                  prepend-icon="attach_file"
                  :disabled="this.filesDca['dca'][3]['saved'] == 'si'"
                ></v-text-field>
                <input
                  type="file"
                  id="file3"
                  ref="myFiles3"
                  style="display: none"
                  class="custom-file-input"
                  @change="previewFiles('3')"
                  multiple
                />
              </v-flex>

              <v-flex md2 xs1>
                <v-btn
                  v-if="this.filesDca['dca'][3]['saved'] == 'si'"
                  fab
                  outline
                  small
                  color="#394049"
                  v-on:click="downloadFile('3')"
                >
                  <v-icon dark>save_alt</v-icon>
                </v-btn>
                <v-btn
                  v-if="this.filesDca['dca'][3]['saved'] == 'no'"
                  fab
                  outline
                  small
                  color="#EC6A12"
                  v-on:click="submitFile('3')"
                  :disabled="disabled[3]"
                >
                  <v-icon color="#394049" dark>publish</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>

          <v-card>
            <v-layout row>
              <v-flex md9 sm9 xs9>
                <v-text-field
                  label="Guía metodológica"
                  @click="pickFile('4')"
                  v-model="FileName[4]"
                  prepend-icon="attach_file"
                  :disabled="this.filesDca['dca'][4]['saved'] == 'si'"
                ></v-text-field>
                <input
                  type="file"
                  id="file4"
                  ref="myFiles4"
                  style="display: none"
                  class="custom-file-input"
                  @change="previewFiles('4')"
                  multiple
                />
              </v-flex>

              <v-flex md2 xs1>
                <v-btn
                  v-if="this.filesDca['dca'][4]['saved'] == 'si'"
                  fab
                  outline
                  small
                  color="#394049"
                  v-on:click="downloadFile('4')"
                >
                  <v-icon dark>save_alt</v-icon>
                </v-btn>
                <v-btn
                  v-if="this.filesDca['dca'][4]['saved'] == 'no'"
                  fab
                  outline
                  small
                  color="#EC6A12"
                  v-on:click="submitFile('4')"
                  :disabled="disabled[4]"
                >
                  <v-icon color="#394049" dark>publish</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>

          <v-card>
            <v-layout row>
              <v-flex md9 sm9 xs9>
                <v-text-field
                  label="Indicadores/evidencia"
                  @click="pickFile('5')"
                  v-model="FileName[5]"
                  prepend-icon="attach_file"
                  :disabled="this.filesDca['dca'][5]['saved'] == 'si'"
                ></v-text-field>
                <input
                  type="file"
                  id="file5"
                  ref="myFiles5"
                  style="display: none"
                  class="custom-file-input"
                  @change="previewFiles('5')"
                  multiple
                />
              </v-flex>

              <v-flex md2 xs1>
                <v-btn
                  v-if="this.filesDca['dca'][5]['saved'] == 'si'"
                  fab
                  outline
                  small
                  color="#394049"
                  v-on:click="downloadFile('5')"
                >
                  <v-icon dark>save_alt</v-icon>
                </v-btn>
                <v-btn
                  v-if="this.filesDca['dca'][5]['saved'] == 'no'"
                  fab
                  outline
                  small
                  color="#EC6A12"
                  v-on:click="submitFile('5')"
                  :disabled="disabled[5]"
                >
                  <v-icon color="#394049" dark>publish</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>

          <v-card class="bot">
            <v-layout row>
              <v-flex md9 xs9>
                <v-text-field
                  label="Reporte UNIE"
                  @click="pickFile('2')"
                  v-model="FileName[2]"
                  prepend-icon="attach_file"
                  :disabled="this.filesDca['dca'][2]['saved'] == 'si'"
                ></v-text-field>
                <input
                  type="file"
                  id="file2"
                  ref="myFiles2"
                  style="display: none"
                  class="custom-file-input"
                  @change="previewFiles('2')"
                  multiple
                />
              </v-flex>

              <v-flex md2 xs1>
                <v-btn
                  v-if="this.filesDca['dca'][2]['saved'] == 'si'"
                  fab
                  outline
                  small
                  color="#394049"
                  v-on:click="downloadFile('2')"
                >
                  <v-icon dark>save_alt</v-icon>
                </v-btn>
                <v-btn
                  v-if="this.filesDca['dca'][2]['saved'] == 'no'"
                  fab
                  outline
                  small
                  color="#EC6A12"
                  v-on:click="submitFile('2')"
                  :disabled="disabled[2]"
                >
                  <v-icon color="#394049" dark>publish</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </div>
    </div>
  </v-container>
</template>


<script>
import img1 from "../../../assets/LOGO USACH.png";

export default {
  /*
      Defines the data used by the component
    */
  data() {
    return {
      loader: "true",
      img1: img1,
      carreras: "",
      carrera: "",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      path: "",
      disabled: [true, true, true, true, true, true],
      file: "",
      filesDca: "",
      filess: {
        0: "",
        1: "",
        2: "",
        3: "",
        4: "",
        5: ""
      },
      FileName: {
        0: "",
        1: "",
        2: "",
        3: "",
        4: "",
        5: ""
      }
    };
  },

  created() {
    axios
      .get(process.env.ROOT_API + "/postgrado/getAll", this.auth)
      .then(response => {
        this.carreras = response.data;
        //console.log(this.carreras);
        this.loader=false
      })
      .catch(error => {
        console.error(error);
      });
  },

  methods: {
    /*
        Submits the file to the server
      */
    submitFile(index) {
      this.loader=true
      /*
                Initialize the form data
            */

      let formData = new FormData();
      var name = this.filess[index].name;
      //console.log("indice: " + index);
      /*
                Add the form data we need to submit
            */
      formData.append("file", this.filess[index]);
      //console.log(formData);

      /*
          Make the request to the POST /single-file URL
        */

      axios
        .post(
          process.env.ROOT_API +
            "/uploadFileDcaEtc/createFile?idCarrera=" +
            this.carrera.id,
          formData,
          this.auth
        )
        .then(response => {
          //console.log("SUCCESS!!");
          //console.log(response.data);
          this.path = response.data;
          this.filesDca.dca[index]["saved"] = "si";
          this.filesDca.dca[index]["path"] = response.data[0];
          this.filesDca.dca[index]["name"] = response.data[1];
          alert("Archivo: " + name + " fue cargado exitosamente.");
          this.loader=false
        })
        .catch(error => {
          //console.log("FAILURE!!");
          alert("Error al cargar el archivo" + name + " ," + error);
          this.loader=false
        })
        .then(response => {
          axios
            .post(
              process.env.ROOT_API +
                "/uploadFileDcaEtc/updateFileValue?idCarrera=" +
                this.carrera.id +
                "&tipoData=dca",
              this.filesDca.dca,
              this.auth
            )
            .then(response => {
              //console.log(response.data);
              //console.log("funcionando");
            })
            .catch(error => {
              console.error(error);
            });
        });
    },

    /*
        Handles a change on the file upload
      */
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      //console.log(this.file);
    },

    cargaArchivos() {
      (this.filess = {
        0: "",
        1: "",
        2: "",
        3: "",
        4: "",
        5: ""
      }),
        (this.FileName = {
          0: "",
          1: "",
          2: "",
          3: "",
          4: "",
          5: ""
        });

      (this.disabled = [true, true, true, true, true, true]),
        //console.log(this.carrera.id);
      axios
        .get(
          process.env.ROOT_API +
            "/uploadFileDcaEtc/getByCcValor?idCarrera=" +
            this.carrera.id,
          this.auth
        )
        .then(response => {
          this.filesDca = response.data;
          //console.log(this.filesDca);
          //console.log(this.filesDca["dca"][1]);
        })
        .catch(error => {
          console.error(error);
        });
    },

    previewFiles(index) {
      //console.log(index);
      this.filess[index] = this.$refs["myFiles" + index].files[0];
      //console.log(this.filess);
      this.FileName[index] = this.$refs["myFiles" + index].files[0].name;
    },
    pickFile(index) {
      //console.log("entrando a pick file");
      this.$refs["myFiles" + index].click();
      this.disabled[index] = false;
    },

    // TODO
    downloadFile(index) {
      //console.log("Descargando archivo ....");
      var pathFile = this.convertPath(this.filesDca.dca[index]["path"]);
      var nameFile = this.filesDca.dca[index]["name"];
      //console.log(nameFile);
      axios
        .get(
          process.env.ROOT_API +
            "/uploadFileDcaEtc/downloadFile?dir=" +
            pathFile,
          {
            responseType: "arraybuffer",
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          //console.log("archivo descargado ....");
          //console.log(response);
          this.forceFileDownload(response, nameFile);
        })
        .catch(error => {
          console.error(error);
        });
    },

    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    },

    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nameFile); //or any other extension
      document.body.appendChild(link);
      link.click();
    }
  }
};
</script>


<style scoped>
.v-card {
  margin-bottom: 1%;
  padding-right: 3%;
  padding-left: 3%;
  padding-top: 0.5%;
}

.top {
  margin-top: 50px;
}

.bot {
  margin-bottom: 50px;
}

.primary--text {
  color: #ec6a12 !important;
  caret-color: #ec6a12 !important;
}

.v-text-field .v-label--active {
  color: #ec6a12 !important;
}

.v-btn--floating.v-btn--small {
  height: 35px !important;
  width: 35px !important;
  margin-top: 15px !important;
}



.containerStyle{
    background-color: black;
    position: fixed;
    z-index: 99999;
    width: 100%;
    height: 100%;
    padding: 20%; 
}

#loader{
  position: relative;
  z-index: 999;
}

.zoom {
  animation: scale 2s linear infinite;
}
  
@keyframes scale {
  50% {
    -webkit-transform:scale(1.2);
    -moz-transform:scale(1.2);
    -ms-transform:scale(1.2);
    -o-transform:scale(1.2);
    transform:scale(1.2);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dca/archivosDca/DcaCarrera.vue